import { Box, Checkbox, FormControlLabel, Grid } from "@mui/material";
import * as React from "react";
import { ConfirmationDialogResult } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppUtils } from "../../../framework/appUtils";
import { SaveDataObj } from "../../../framework/saveData";
import { FilterButtons } from "../../framework/Filters/FilterButtons";
import { FormField } from "../../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/components/framework/FormField";
import { GridRow } from "../../framework/Grid/GridRow";
import { PageDrawer } from "../../framework/Page/PageDrawer";
import { AppSettingsIcon } from "source/components/framework/Icon/AppSettingsIcon";
import { IdTitleDropdown } from "ui/Scripts/source/components/framework/Dropdown/IdTitleDropdown";

//FrontPanelPropertiesDialog
export interface IFrontPanelPropertiesDialogProp {
    classes?: string;
    id: string;
    title: string;
    panelSize: number;
    panelType: number;
    visible: boolean;
    hidePanelSize?: boolean;
    onOk: (id: string, panelType: number, panelSize: number, visible: boolean) => void;
    onCancel: () => void;
}

export interface IFrontPanelPropertiesDialogState {
    panelSize: string;
    visible: boolean;
}

export class FrontPanelPropertiesDialog extends React.Component<IFrontPanelPropertiesDialogProp, IFrontPanelPropertiesDialogState> {
    private orgStateHash: string = "";

    constructor(props: IFrontPanelPropertiesDialogProp) {
        super(props);
        this.state = {
            panelSize: props.panelSize.toString(10),
            visible: props.visible
        };
        //console.log(props.visible);
        
        const saveData = this.getSaveDataFromState(props, this.state);
        this.orgStateHash = saveData.hash;
    }

    changeVisibility = (visible: boolean) => {
        this.setState({ visible });
    };

    getSaveDataFromState = (props: IFrontPanelPropertiesDialogProp, state: IFrontPanelPropertiesDialogState): SaveDataObj => {
        const result = new SaveDataObj();
        result.append("panelSize", state.panelSize);
        return result;
    };

    saveToDb = async () => {
        const props = this.props;
        const state = this.state;
        props.onOk(props.id, props.panelType, state.panelSize.toInteger(), state.visible);
    };

    handleSave = () => {
        this.saveToDb();
    };

    handleCancel = async () => {
        const props = this.props;
        const state = this.state;
        const cancelResult = await AppUtils.cancel(this.getSaveDataFromState(props, state).hash, this.orgStateHash);
        if (cancelResult === ConfirmationDialogResult.Cancel) return;
        if (cancelResult === ConfirmationDialogResult.Yes) {
            this.saveToDb();
        } else {
            props.onCancel();
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <PageDrawer
                open
                icon={<AppSettingsIcon />}
                title={props.title}
                parentTitle={Translations.Panels}
                onClose={this.handleCancel}
            >
                <Box display="flex" flexDirection="column" flexGrow={2} margin="24px">
                    <Box display="flex" flexDirection="column" flexGrow={2}>
                        <GridRow>
                            <Grid item sm={12}>
                                <FormControlLabel
                                    label={Translations.PanelVisible}
                                    control={
                                        <Checkbox
                                            checked={state.visible}
                                            onChange={(_e, checked) => this.changeVisibility(checked)}
                                        />
                                    }
                                />
                            </Grid>
                        </GridRow>
                        {!props.hidePanelSize &&
                            <GridRow>
                                <Grid item sm={12}>
                                    <FormField title={Translations.PanelSize}>
                                        <IdTitleDropdown
                                            selectedId={state.panelSize}
                                            items={[
                                                { id: "1", title: Translations.PanelSize1 },
                                                { id: "2", title: Translations.PanelSize2 },
                                                { id: "5", title: Translations.PanelSize5 },
                                                { id: "3", title: Translations.PanelSize3 },
                                                { id: "4", title: Translations.PanelSize4 },
                                                { id: "6", title: Translations.PanelSize6 }
                                            ]}
                                            onChange={(panelSize) => this.setState({ panelSize })}
                                        />
                                    </FormField>
                                </Grid>
                            </GridRow>
                        }
                    </Box>
                    <FilterButtons
                        chartPanelPropertiesMode
                        onCancel={this.handleCancel}
                        onSave={this.handleSave}
                    />
                </Box>
            </PageDrawer>
        );
    }
}